import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import navLogo from "../img/technicblue.png";
import { useContext } from "react";
import MyContext from "../ContextApi/MyContext";  // adjust path if needed

export default function Navbar() {
  const { user, logout } = useContext(MyContext);

  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/user-login", { replace: true });
  };

  const closeNavbarOnItemClick = () => {
    if (window.innerWidth <= 768) {
      setIsNavbarCollapsed(true);
    }
  };

  // Routes where navbar should be completely hidden
  const hiddenRoutes = [
    "/adminPanel/addblog",
    "/adminPanel/allposts",
    "/adminPanel/allcategory",
    "/adminPanel/addcategory",
    "/adminPanel/alltickets",
    "/adminPanel/board",
    "/user-profile/ticket-generate",
    "/user-profile/generated-tickets",
    "/user-profile/close-status-tickets",
    "/user-profile/open-status-tickets",
  ];

  if (hiddenRoutes.includes(location.pathname)) {
    return null;
  }

  const isLinkActive = (linkPath) =>
    linkPath === location.pathname ||
    (linkPath === "/manual" && location.pathname.startsWith("/manual"))
      ? "active"
      : "";

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light" id="navbarSupportedContent">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/" onClick={closeNavbarOnItemClick}>
          <img
            src={navLogo}
            style={{ maxWidth: "14rem", marginLeft: "5%" }}
            alt="it-services-company"
          />
          <span className="d-none">Technic Mentors Software Solutions</span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
          aria-controls="navbarSupportedContent"
          aria-expanded={!isNavbarCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`collapse navbar-collapse ${isNavbarCollapsed ? "" : "show"}`}
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ms-auto" style={{ maxWidth: "120%", marginRight: "3%" }}>
            {/* Home */}
            <li className="nav-item">
              <Link
                className={`nav-link text-dark ${isLinkActive("/")}`}
                to="/"
                style={{ fontSize: "1.1rem" }}
                onClick={closeNavbarOnItemClick}
              >
                Home
              </Link>
            </li>

            {/* About dropdown */}
            <li className="nav-item dropdown">
              <Link
                to="#"
                className="nav-link dropdown-toggle text-dark"
                style={{ fontSize: "17px" }}
                data-bs-toggle="dropdown"
              >
                About
              </Link>
              <div className="dropdown-menu rounded services-dropdown">
                <Link to="/about" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Who We Are
                </Link>
                <Link to="/team" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Our Team
                </Link>
                <Link to="/portfolio" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Our Portfolio
                </Link>
              </div>
            </li>

            {/* Services dropdown */}
            <li className="nav-item dropdown">
              <Link
                to="/services"
                className="nav-link dropdown-toggle text-dark"
                style={{ fontSize: "17px" }}
                data-bs-toggle="dropdown"
              >
                Services
              </Link>
              <div className="dropdown-menu rounded services-dropdown">
                <Link to="/web-development-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Web Design & Development
                </Link>
                <Link to="/software-development-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Software Development
                </Link>
                <Link to="/mobile-app-development-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Mobile App Development
                </Link>
                  <Link to="/ecommerce-solutions" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                  Ecommerce Solutions
                </Link>
                <Link to="/seo-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  SEO Services
                </Link>
                <Link to="/digital-marketing-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Digital Marketing
                </Link>
                <Link to="/graphics-designing-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                  Graphics Designing
                </Link>
              </div>
            </li>

            {/* Products dropdown */}
            <li className="nav-item dropdown">
              <Link
                to="/products"
                className="nav-link dropdown-toggle text-dark"
                style={{ fontSize: "17px" }}
                data-bs-toggle="dropdown"
              >
                Products
              </Link>
              <div className="dropdown-menu rounded">
                <Link to="/school-management-system" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                 CapoBrain 
                </Link>
                <Link to="/business-management-solutions" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                CapoBiz
                </Link>
              
                {/* <Link to="/restuarent-management-system" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                  Restaurant Management System
                </Link> */}
                 <Link to="" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
             MyDesk
                </Link>
                     <Link to="" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
             Mobile Apps
                </Link>
                      <Link to="" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
          Games
                </Link>
              </div>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link text-dark"
                to="/industries"
                style={{ fontSize: "1.1rem" }}
                onClick={closeNavbarOnItemClick}
              >
                Industries
              </Link>
            </li>

            {/* ─── Help Center ─── */}
         

            {/* ─── User Icon (only when logged in) ─── */}
            {user && (
              <li className="nav-item dropdown">
                <div
                  className="nav-link dropdown-toggle text-dark d-flex align-items-center"
                  style={{ fontSize: "1.1rem", cursor: "pointer", paddingTop: "1.2rem" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                 <i className="fas fa-user-circle fa-lg"></i>
                </div>
                <ul className="dropdown-menu dropdown-menu-end">
               
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/user-profile"
                      onClick={closeNavbarOnItemClick}
                    >
                      Profile
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={() => {
                        closeNavbarOnItemClick();
                        handleLogout();
                      }}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            )}

            {/* ─── Login link (only when NOT logged in) ─── */}
            {!user && (
              <li className="nav-item">
                <Link
                  className="nav-link text-dark"
                  to="/user-login"
                  style={{ fontSize: "1.1rem" }}
                  onClick={closeNavbarOnItemClick}
                >
                  Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}